import React from "react";
import { useTranslation } from "react-i18next";
import { useParams, Link } from "react-router-dom";
import "./BlogPost.scss";

const BlogPost = () => {
  const { t } = useTranslation();
  const { id, lang } = useParams();

  // Get the post from locale
  const post = t(`blog.posts.${id - 1}`, { returnObjects: true });

  if (!post) return null;

  // Assume post.full is now an array of sections: [{number: "1.", title: "...", text: "..."}]
  const sections = post.full;

  return (
    <main className="blog-post">
      <div className="blog-post__container">
        <Link to={`/${lang}/blog`} className="blog-post__back">
          ← {t("blog.back")}
        </Link>

        <header className="blog-post__header">
          <h1 className="blog-post__title">{post.title}</h1>
          <span className="blog-post__date">{post.date}</span>
          {/* <img
            src={post.image}
            alt={post.title}
            className="blog-post__image"
          /> */}
        </header>

       <section className="blog-post__content">
  {sections.map((section, idx) => (
    <div key={idx} className="blog-post__section">
      <p>
        <strong>
          {section.number} {section.title}
        </strong>
      </p>

      {/* image */}
      {section.image && (
        <div className="blog-post__section-image-wrapper">
          <img
            src={section.image}
            alt={section.title}
            className="blog-post__section-image"
          />
        </div>
      )}

      {/* Paragraphs */}
      {section.text.split("\n").map((para, i) => (
        <p key={i}>{para}</p>
      ))}
    </div>
  ))}
</section>
      </div>
    </main>
  );
};

export default BlogPost;